<!-- Responsibility: Render the reusable notebook dialog content surface.
Scope: Notebook dialog content only; modal lifecycle is owned by game-modal/app-shell. -->
<notebook-dialog>
  <section if={ hasSections() } class="fm-notebook-hero">
    <div class="fm-meta">{ meta() }</div>
    <div class="fm-notebook-hero-main">
      <strong class="fm-notebook-summary">{ summary() }</strong>
      <span class="fm-notebook-topic-count">{ sectionCountLabel() }</span>
    </div>
  </section>
  <div if={ !hasSections() && meta() } class="fm-meta">{ meta() }</div>
  <p if={ desc() } class="fm-desc">{ desc() }</p>

  <div if={ hasSections() } class="fm-notebook">
    <section each={ section in sections() } class="fm-notebook-section { isSectionOpen(section.key) ? 'open' : '' }">
      <button
        class="fm-notebook-toggle"
        onclick={ () => toggleSection(section.key) }
        aria-expanded={ isSectionOpen(section.key) ? 'true' : 'false' }
      >
        <span class="fm-notebook-toggle-main">
          <span class="fm-notebook-label">{ section.label }</span>
          <span class="fm-notebook-count">{ sectionTotal(section) }</span>
        </span>
        <span class="fm-notebook-caret">{ isSectionOpen(section.key) ? '▾' : '▸' }</span>
      </button>
      <ol if={ isSectionOpen(section.key) } class="fm-notebook-list">
        <li each={ entry in section.entries }>{ entry }</li>
      </ol>
      <div if={ isSectionOpen(section.key) && (section.overflow ?? 0) > 0 } class="fm-overflow-note">
        +{ section.overflow } more entries hidden.
      </div>
    </section>
  </div>

  <script>
    export default {
      state: {
        sectionOpen: {},
      },

      onMounted() {
        this.openToken = Number(this.props.openToken || 0)
        this.update({ sectionOpen: this.defaultOpenState(this.model()) })
      },

      onBeforeUpdate(props, state) {
        const token = Number(props.openToken || 0)
        if (token === this.openToken) return
        this.openToken = token
        state.sectionOpen = this.defaultOpenState(this.model(props))
      },

      model(props = this.props) {
        return props.content?.model
      },

      desc() {
        return String(this.props.content?.desc ?? '').trim()
      },

      meta() {
        return String(this.props.content?.meta ?? '').trim()
      },

      defaultOpenState(model) {
        if (!model || typeof model.initialOpenState !== 'function') return {}
        return model.initialOpenState()
      },

      sections() {
        return Array.isArray(this.model()?.sections) ? this.model().sections : []
      },

      hasSections() {
        return this.sections().length > 0
      },

      sectionCount() {
        return this.sections().length
      },

      sectionCountLabel() {
        const count = this.sectionCount()
        return count === 1 ? '1 active section' : `${count} active sections`
      },

      summary() {
        const model = this.model()
        if (!model?.totalEntries) return 'Notebook standing by.'
        return model.totalEntries === 1
          ? '1 recorded clue in your field notebook.'
          : `${model.totalEntries} recorded clues in your field notebook.`
      },

      sectionTotal(section) {
        const visible = Array.isArray(section?.entries) ? section.entries.length : 0
        const overflow = Math.max(0, Number(section?.overflow ?? 0) || 0)
        return visible + overflow
      },

      isSectionOpen(sectionKey) {
        const key = String(sectionKey ?? '').trim().toLowerCase()
        if (!key) return false
        return this.state.sectionOpen?.[key] === true
      },

      toggleSection(sectionKey) {
        const key = String(sectionKey ?? '').trim().toLowerCase()
        if (!key) return
        const next = { ...(this.state.sectionOpen || {}) }
        next[key] = !next[key]
        this.update({ sectionOpen: next })
      },
    }
  </script>
</notebook-dialog>
